import { render, staticRenderFns } from "./ProductPolicySection.vue?vue&type=template&id=c54521e6"
import script from "./ProductPolicySection.vue?vue&type=script&lang=js"
export * from "./ProductPolicySection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c54521e6')) {
      api.createRecord('c54521e6', component.options)
    } else {
      api.reload('c54521e6', component.options)
    }
    module.hot.accept("./ProductPolicySection.vue?vue&type=template&id=c54521e6", function () {
      api.rerender('c54521e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/cancellation/ProductPolicySection.vue"
export default component.exports